import React from 'react';
import GpyToggleButton from './GpyToggleButton.js';
import {_GPY} from '../../../env.js'

class GpyPenaltyButton extends React.Component {

  constructor(props) {
			super(props);
			this.state = {
			};
  }

	render() {
     let sb = this.props.scoreboard;
     let name = this.props.name;
     let clockName = this.props.clockName;
     let milis = this.props.countDownTime;
     let repeat = this.props.repeat;
     let clockStateName = sb.getName()+"_"+clockName;
     return  (
          <GpyToggleButton
              title={_GPY.i18n.get('gametype_'+sb.getName()+'_scoreboard_'+name)}
              onInit={() => {return {}}}
              onprepareRestart={()=>{
              }}
              onDeactivate={() => { sb.onPlayTime( clockStateName ,"stop"); return {visible: false}}}
              onActivate={() => {
                 if(sb.getMainClock() !== undefined) {
                   if(sb.getMainClock().isActive()){
                     sb.startTimeAt( clockStateName , milis);
                   } else {
                     sb.setTimeTo(  clockStateName , milis);
                   }
                 }
                return {visible: true, type:"Powerplay",
                  nonAutoStart: !sb.getMainClock().isActive(),
                  team: sb.state.currentGame.teamMap.HOME_TEAM,
                  message: _GPY.i18n.get('gametype_'+sb.getName()+'_scoreboard_message_'+name)}}}
              scoreboard={sb}
              getTime={()=>sb.getCurrentMainTime()} getGameId={()=>sb.getCurrentGameId()}
              autoexpirytime={milis/1000}
              autoexpiryRestart={repeat>0?1000:undefined}
              autoexpiryRestartCount={repeat}
              stateName={sb.getName()+"_button_"+name}
           />
      );
	}
}
export default GpyPenaltyButton;
